import "./vendor.ts";
import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production)
    enableProdMode();
// platformBrowserDynamic().bootstrapModule(AppModule);
let p = __NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory);
p.then(() => { window.appBootstrap && window.appBootstrap(); });
// .catch(err => console.error(err));
